import { ViewEnsaioAliquotaAtual } from '@models/views/view-ensaio-aliquota-atual.model';
import { ViewEnsaioAtual } from '@models/views/view-ensaio-atual.model';
import { maxBy } from 'lodash';
import { TipoEnsaioMetodoEnum } from '../../../back/src/ensaios-metodos/ensaios-metodos.constants';
import { TipoEnsaioEnum } from '../../../back/src/ensaios/ensaios.constants';

export interface IEnsaioEspecifico {
  ensaioForm: string;
  color: string;
  icon: string;
}

export function getEnsaioEspecifico(
  ensaioMetodoTipo: TipoEnsaioMetodoEnum,
): IEnsaioEspecifico | null {
  switch (ensaioMetodoTipo) {
    case TipoEnsaioMetodoEnum.CALCINACAO:
      return {
        ensaioForm: 'EnsaiosFormCalcinacao',
        color: 'deep-orange',
        icon: 'mdi-fire',
      };
    case TipoEnsaioMetodoEnum.UMIDADE_ESTUFA:
      return {
        ensaioForm: 'EnsaiosFormUmidadeEstufa',
        color: 'cyan',
        icon: 'mdi-water',
      };
    case TipoEnsaioMetodoEnum.CARBONO:
      return {
        ensaioForm: 'EnsaiosFormCarbono',
        color: '#b71c1c',
        icon: 'mdi-hexagon-multiple',
      };
    case TipoEnsaioMetodoEnum.UMIDADE_BALANCA:
      return {
        ensaioForm: 'EnsaiosFormUmidadeBalanca',
        color: 'cyan',
        icon: 'mdi-water',
      };
    case TipoEnsaioMetodoEnum.FRX:
      return {
        ensaioForm: 'EnsaiosFormFRX',
        color: 'amber',
        icon: 'mdi-lightning-bolt',
      };
    case TipoEnsaioMetodoEnum.FRX_QUALITATIVO:
      return {
        ensaioForm: 'EnsaiosFormFRXQualitativo',
        color: 'amber',
        icon: 'mdi-lightning-bolt-circle',
      };
    case TipoEnsaioMetodoEnum.GRAVIMETRIA:
      return {
        ensaioForm: 'EnsaiosFormGravimetria',
        color: 'green',
        icon: 'mdi-gold',
      };
    case TipoEnsaioMetodoEnum.ICP:
      return {
        ensaioForm: 'EnsaiosFormICP',
        color: 'brown',
        icon: 'mdi-lightbulb-fluorescent-tube',
      };
    case TipoEnsaioMetodoEnum.ICP_COBRE:
      return {
        ensaioForm: 'EnsaiosFormICPCobre',
        color: 'orange',
        icon: 'mdi-lightbulb-fluorescent-tube-outline',
      };
    default:
      return null;
  }
}
export function getTipoEnsaio(ensaio: ViewEnsaioAtual): string {
  if (ensaio.rotina) {
    return TipoEnsaioEnum.ROTINA;
  }
  if (ensaio.reanalise) {
    return TipoEnsaioEnum.REANALISE;
  }
  return TipoEnsaioEnum.EXTRA_ROTINA;
}

export function getDataEnsaio(ensaio: ViewEnsaioAtual): Date {
  return maxBy(
    ensaio.ensaiosAliquotasAtuais,
    (aliquota: ViewEnsaioAliquotaAtual) => aliquota.logResultadosAtualCreatedAt,
  )?.logResultadosAtualCreatedAt;
}

export const ensaiosMetodosOrder = {
  [TipoEnsaioMetodoEnum.CALCINACAO]: 0,
  [TipoEnsaioMetodoEnum.CARBONO]: 5,
  [TipoEnsaioMetodoEnum.FRX]: 7,
  [TipoEnsaioMetodoEnum.FRX_QUALITATIVO]: 8,
  [TipoEnsaioMetodoEnum.GRAVIMETRIA]: 2,
  [TipoEnsaioMetodoEnum.ICP]: 3,
  [TipoEnsaioMetodoEnum.ICP_COBRE]: 4,
  [TipoEnsaioMetodoEnum.UMIDADE_ESTUFA]: 1,
  [TipoEnsaioMetodoEnum.UMIDADE_BALANCA]: 6,
};
